import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation UpdateQuotationMutation($data: QuotationUpdateInput!) {
        updateQuotation(data:$data) {
            id
      }
    }
  `

export default (data, callback) => {
    const variables = {
        data
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.updateQuotation })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}